import { array, defineAction, enumerated, number, object, string } from '~/prix'
import agentReportPolygonInsightAction from './agentReportPolygonInsight.action.json'
import { point, polygon } from '~/prix/types/geoJson'

const agentReportPolygonInsightDefinition = defineAction({
  ...agentReportPolygonInsightAction,
  input: object({
    point: point().label('Coordenada'),
    radius: number(),
    boundary: polygon().label('Polígono'),
    geoItems: array(
      object({
        level: enumerated({
          country: 'country',
          macroRegion: 'macroRegion',
          mesoRegion: 'mesoRegion',
          microRegion: 'microRegion',
          state: 'state',
          city: 'city',
          street: 'street',
          neighborhood: 'neighborhood',
          suburb: 'suburb',
        }),
        id: string().label('Id do nível selecionado'),
      }),
    ),
  }),
  output: object({}),
})

export default agentReportPolygonInsightDefinition
